var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Home',{ref:"home",on:{"showSelectedYear":_vm.showSelectedYear}}),_c('Footer'),_c('Picker',{ref:"picker",on:{"refreshHomeYear":_vm.refreshHomeYear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }